import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { eventBus } from '@kbbsdk/global-sdk/eventBus/eventBus';

import authDuck from '@/ducks/authDuck.js';

function LoginListener() {
    const dispatch = useDispatch();

    useEffect(() => {
        ['auth.signout', 'auth.signin'].forEach((eventName) => {
            eventBus.on(eventName, () => {
                dispatch(authDuck.creators.setLoggedIn());
            });
        });
    }, [dispatch]);

    return null;
}

export default React.memo(LoginListener);
